<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addPrinter"
            >新建打印规则</el-button
          >
          <el-button size="small" @click="linkTo('/setting/print/template')"
            >模板管理</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <!-- <el-tabs v-model="activeName" type="card">
                    <el-tab-pane
                        v-for="(item, index) in pathList"
                        :key="String(item.path)"
                        :label="item.name"
                        :name="String(index)"
                    ></el-tab-pane>
                </el-tabs> -->
        <div class="list" v-loading="isListLoad">
          <el-table :data="printRuleList" style="width: 100%">
            <el-table-column label="打印机规则名称">
              <template slot-scope="scope">
                <div class="name">
                  {{ scope.row.printRuleName }}-{{
                    scope.row.autoPrint ? "自动打印" : "手动打印"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="设备备注名称/型号">
              <template slot-scope="scope">
                <div class="item-count">{{ scope.row.printDeviceNames }}</div>
              </template>
            </el-table-column>
            <el-table-column label="打印类型">
              <template slot-scope="scope">
                <div class="item-count">
                  {{ printTypeOptions[scope.row.printType] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button size="small" type="primary" @click="edit(scope.$index)" plain
                    >编辑</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="del(scope.row.printRuleId)"
                    plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        background
                        layout="prev, pager, next, jumper"
                        :total="count"
                    ></el-pagination>-->
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogAddRuleVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="510px"
      @close="addRuleDialogClose"
    >
      <div slot="title" class="dialog-title">
        {{ addRuleForm.printRuleId ? "编辑普通打印规则" : "新增普通打印规则" }}
      </div>
      <el-form
        :model="addRuleForm"
        :rules="addRuleFormRule"
        ref="addRuleForm"
        label-width="108px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="打印规则名称" prop="printRuleName">
          <el-input
            v-model="addRuleForm.printRuleName"
            placeholder="请填写打印规则名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="打印模板" prop="printTempType">
          <el-select v-model="addRuleForm.printTempType" placeholder="请选择打印模板">
            <el-option
              v-for="item in templateList"
              :key="item.id"
              :label="`${item.name}`"
              :value="Number(item.id)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="打印场景">
          <el-radio-group v-model="addRuleForm.printStage" @change="printStageChange">
            <el-radio :label="1">结算打印</el-radio>
            <el-radio :label="2">厨房打印</el-radio>
            <el-radio :label="3">菜单打印</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打印类型">
          <el-radio-group v-model="addRuleForm.printType">
            <el-radio :label="1">普通小票</el-radio>
            <el-radio :label="2">分单小票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="一菜一单" v-if="addRuleForm.printStage == 2"
          >(仅限厨打)
          <el-radio-group v-model="addRuleForm.isSeperateForKitchen">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打印退菜单" v-if="addRuleForm.printStage == 2"
          >(仅限厨打)
          <el-radio-group v-model="addRuleForm.isFallbackmenu">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="打印商品分类"
          prop="goodsCategorys"
          v-if="addRuleForm.printType == 2"
        >
          <el-cascader
            placeholder="请选择打印商品"
            v-model="addRuleForm.goodsCategorys"
            :options="classifyList"
            :props="{ multiple: true }"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="打印商品"
          prop="goodsCategorys"
          v-if="addRuleForm.printType == 2"
        >
          <el-cascader
            placeholder="请选择打印商品"
            v-model="addRuleForm.goodsIds"
            :options="goodsList"
            :props="{ multiple: true }"
            filterable
          ></el-cascader>
        </el-form-item>
        <div class="dialog-title">打印设置</div>
        <el-form-item label="自动打印">
          <el-radio-group v-model="addRuleForm.autoPrint" @change="autoPrintChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打印时间" v-if="addRuleForm.autoPrint">
          <el-radio-group
            v-model="addRuleForm.printStep"
            :disabled="addRuleForm.printStage == 1"
          >
            <el-radio :label="1">提交订单时打印</el-radio>
            <el-radio :label="2">支付成功时打印</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打印张数" prop="printPageNum">
          <el-input-number
            size="small"
            :disabled="!addRuleForm.autoPrint"
            v-model="addRuleForm.printPageNum"
            :min="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="打印设备" prop="printDevices">
          <el-select
            v-model="addRuleForm.printDevices"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择打印设备"
          >
            <el-option
              v-for="item in printerDeviceList"
              :key="item.printerDevicesId"
              :label="`${item.deviceName} ${deviceType[item.deviceType - 1]}`"
              :value="item.printerDevicesId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="save"
          :loading="isSubmit"
          :disabled="isLoadEnd ? false : true"
          >保存</el-button
        >
        <el-button @click="dialogAddRuleVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLodop } from "@/utils/LodopFuncs.js";
import {
  getPrintRules,
  getCountPrintRules,
  getPrinterDevices,
  savePrintRule,
  batchSaveLocalPrint,
  delPrintRule,
  getEdcShopGoodsCategorys,
  getFindAllGoods,
} from "@/api/index.js";
export default {
  data() {
    return {
      pathList: [
        {
          name: "普通小票",
          path: "/setting/print/normal",
        },
        {
          name: "分单小票",
          path: "/setting/print/split",
        },
      ],
      templateList: [
        {
          name: "堂食模板",
          id: 1,
        },
        {
          name: "外卖模板",
          id: 2,
        },
      ],
      printTypeOptions: {
        1: "普通小票",
        2: "分单小票",
        3: "标签",
      },
      printRuleList: [],
      printerDeviceList: [],
      deviceType: ["云打印机", "PC本地打印机", "APP本地打印机"],
      activeName: "0",
      count: 0,
      pageSize: 5,
      dialogAddRuleVisible: false,
      addRuleForm: {
        printTempType: "",
        printRuleName: "",
        autoPrint: 1,
        printStep: 2,
        printPageNum: 1,
        printDevices: [],
        printType: 1,
        goodsCategorys: [],
        printStage: 1,
        goodsIds: [],
        isSeperateForKitchen: 0,
        isFallbackmenu: 0,
      },
      addRuleFormRule: {
        printRuleName: [
          {
            required: true,
            message: "请填写打印规则名称",
            trigger: "blur",
          },
        ],
        printTempType: [
          {
            required: true,
            message: "请选择打印模板",
            trigger: "blur",
          },
        ],
        printDevices: [
          {
            type: "array",
            required: true,
            message: "请选择打印设备",
            trigger: "blur",
          },
        ],
      },
      isListLoad: false,
      isSubmit: false,
      classifyList: [
        {
          value: "0",
          label: "全选",
          children: [],
        },
      ],
      goodsList: [
        {
          value: "0",
          label: "全选",
          children: [],
        },
      ],
      mapGoodsList: {},
      isLoadEnd: false,
    };
  },
  watch: {
    activeName(val) {
      this.$router.push({
        path: this.pathList[val].path,
      });
    },
  },
  mounted() {
    this.getEdcShopGoodsCategorys();
    this.getPageData();
    // setTimeout(() => {
    //     this.getLodopData();
    // }, 1000);
  },
  methods: {
    getLodopData() {
      let LODOP = getLodop();
      console.log(LODOP);
      let arr = [];
      let iPrinterCount = LODOP.GET_PRINTER_COUNT();
      for (let i = 0; i < iPrinterCount; i++) {
        arr.push({
          deviceType: 2,
          deviceName: LODOP.GET_PRINTER_NAME(i),
          usePl: 0,
          deviceIdentifier: LODOP.GET_PRINTER_NAME(i),
          channelId: 0,
        });
      }
      let defaultName = LODOP.GET_PRINTER_NAME("-1"); //GET_PRINTER_NAME(intPrinterIndex);用序号获得打印机名，一般序号从0开始，-1特指默认打印机；
      arr.forEach((item) => {
        if (item.label === defaultName) {
          item.value = "-1";
          item.label += "-默认打印机";
        }
      });

      console.log(arr, defaultName);
      batchSaveLocalPrint({
        recordJson: JSON.stringify(arr),
      }).then((res) => {
        if (res.code == 1) {
          console.log(res);
        }
      });
    },
    getPageData() {
      this.isListLoad = true;
      this.getPrintRules(1);
      getCountPrintRules({}).then((res) => {
        if (res.code == 1) {
          this.count = res.data;
        }
      });
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          let list = [];
          res.data.forEach((val, index) => {
            list[index] = {};
            list[index].value = val.goodsCategoryId;
            list[index].label = val.categoryName;
          });
          this.classifyList[0].children = JSON.parse(JSON.stringify(list));
          this.goodsList[0].children = JSON.parse(JSON.stringify(list));
          this.goodsList[0].children.forEach((val, index) => {
            this.getGoodsList(val.value, index);
          });
        }
      });
    },
    async addPrinter() {
      await getPrinterDevices().then((res) => {
        if (res.code == 1) {
          this.printerDeviceList = res.data;
        }
      });
      this.dialogAddRuleVisible = true;
    },
    tabsChange(val) {},
    handleSizeChange(e) {
      console.log(e);
    },
    handleCurrentChange(e) {
      this.getPrintRules(e);
    },
    getPrintRules(pageNo) {
      getPrintRules({
        pageNo: pageNo,
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (!val.isSeperateForKitchen) {
              val.isSeperateForKitchen = 0;
            }
            if (!val.isFallbackmenu) {
              val.isFallbackmenu = 0;
            }
          });
          this.printRuleList = res.data;
        }
        if (res.code == -1) {
          this.printRuleList = [];
        }
        this.isListLoad = false;
      });
    },
    del(id) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delPrintRule({
              printRuleId: id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    edit(index) {
      if (!this.isLoadEnd) {
        return this.$notify({
          title: "提示",
          message: "商品加载中",
          type: "error",
          duration: 2000,
        });
      }
      this.addRuleForm = JSON.parse(JSON.stringify(this.printRuleList[index]));
      this.addRuleForm.printDevices = this.addRuleForm.printDevices.split(",");
      this.addRuleForm.printDevices.forEach((val, index) => {
        this.addRuleForm.printDevices[index] = Number(val);
      });
      if (this.addRuleForm.goodsCategorys && this.addRuleForm.goodsCategorys.length) {
        this.addRuleForm.goodsCategorys = this.addRuleForm.goodsCategorys.split(",");
        this.addRuleForm.goodsCategorys.forEach((val, index) => {
          this.addRuleForm.goodsCategorys[index] = ["0", Number(val)];
        });
      }
      if (this.addRuleForm.goodsIds && this.addRuleForm.goodsIds.length) {
        this.addRuleForm.goodsIds = this.addRuleForm.goodsIds.split(",");
        this.addRuleForm.goodsIds.forEach((val, index) => {
          // console.log(this.mapGoodsList, this.mapGoodsList[val], val);
          if (this.mapGoodsList[val]) {
            this.addRuleForm.goodsIds[index] = [
              "0",
              this.mapGoodsList[val].goodsCategoryId,
              Number(val),
            ];
          }
        });
      }
      console.log(this.addRuleForm);
      this.addPrinter();
    },
    save() {
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let Param = Object.assign({}, this.addRuleForm);
          Param.printDevices = this.addRuleForm.printDevices.join(",");
          Param.goodsCategorys = "";
          if (this.addRuleForm.goodsCategorys) {
            console.log(this.addRuleForm.goodsCategorys);
            this.addRuleForm.goodsCategorys.forEach((val, index) => {
              if (this.addRuleForm.goodsCategorys.length == index + 1) {
                Param.goodsCategorys += val[1];
              } else {
                Param.goodsCategorys += `${val[1]},`;
              }
            });
          }
          Param.goodsIds = "";
          if (this.addRuleForm.goodsIds) {
            console.log(this.addRuleForm.goodsIds);
            this.addRuleForm.goodsIds.forEach((val, index) => {
              if (this.addRuleForm.goodsIds.length == index + 1) {
                Param.goodsIds += val[2];
              } else {
                Param.goodsIds += `${val[2]},`;
              }
            });
          }
          savePrintRule(Param).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: Param.printRuleId ? "编辑成功" : "创建成功",
                type: "success",
                duration: 2000,
              });
              this.getPageData();
              this.dialogAddRuleVisible = false;
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
            setTimeout(() => {
              this.isSubmit = false;
            }, 500);
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    getGoodsList(goodsCategoryId, index) {
      getFindAllGoods({
        goodsCategoryId,
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        this.goodsList[0].children[index].children = [];
        if (res.code == 1) {
          res.data.forEach((val) => {
            this.goodsList[0].children[index].children.push({
              label: val.goodsName,
              value: val.goodsId,
            });
            this.mapGoodsList[val.goodsId] = {
              goodsCategoryId: goodsCategoryId,
              goodsId: val.goodsId,
            };
          });
          if (this.goodsList[0].children.length == index + 1) {
            this.isLoadEnd = true;
          }
        }
        if (res.code == -1) {
          // this.goodsList = [];
        }
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    addRuleDialogClose() {
      this.addRuleForm = {
        printTempType: "",
        printRuleName: "",
        autoPrint: 1,
        printStep: 2,
        printPageNum: 1,
        printDevices: [],
        printType: 1,
        goodsCategorys: [],
        printStage: 1,
        goodsIds: [],
        isSeperateForKitchen: 0,
        isFallbackmenu: 0,
      };
    },
    autoPrintChange(val) {
      if (!val) {
        this.addRuleForm.printPageNum = 1;
      }
    },
    printStageChange(val) {
      if (val == 1) {
        this.addRuleForm.printStep = 2;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 20px;
  }
  .el-dialog {
    .el-select {
      width: 100%;
    }
    .dialog-title {
      font-weight: bold;
    }
    .ruleForm-bottom {
      margin-top: 20px;
    }
  }
}
</style>
